
import { jsPDF } from "jspdf";

export function generateCustomPDF({

  imagePreview,

  labelWidth,

  labelHeight,

  gridGap,

  showBorder,

}) {

  const pdf = new jsPDF({

    orientation: "landscape",

    unit: "mm",

    format: [460, 305],

  });

  const PAGE_WIDTH = 460;
  const PAGE_HEIGHT = 305;

  const MARGIN = 10;

  const LABEL_WIDTH =
    Number(labelWidth) * 10;

  const LABEL_HEIGHT =
    Number(labelHeight) * 10;

  const GAP =
    Number(gridGap || 0);

  const usableWidth =
    PAGE_WIDTH -
    (MARGIN * 2);

  const usableHeight =
    PAGE_HEIGHT -
    (MARGIN * 2);

  const cols = Math.floor(
    (usableWidth + GAP) /
    (LABEL_WIDTH + GAP)
  );

  const rows = Math.floor(
    (usableHeight + GAP) /
    (LABEL_HEIGHT + GAP)
  );

  const usedWidth =
    cols * LABEL_WIDTH +
    ((cols - 1) * GAP);

  const usedHeight =
    rows * LABEL_HEIGHT +
    ((rows - 1) * GAP);

  const startX =
    MARGIN +
    (
      usableWidth -
      usedWidth
    ) / 2;

  const startY =
    MARGIN +
    (
      usableHeight -
      usedHeight
    ) / 2;

  const totalLabels =
    rows * cols;

  const imageFormat =
    imagePreview?.startsWith(
      "data:image/png"
    )
      ? "PNG"
      : "JPEG";

  for (
    let row = 0;
    row < rows;
    row++
  ) {

    for (
      let col = 0;
      col < cols;
      col++
    ) {

      const x =
        startX +
        (
          col *
          (
            LABEL_WIDTH +
            GAP
          )
        );

      const y =
        startY +
        (
          row *
          (
            LABEL_HEIGHT +
            GAP
          )
        );

      if (imagePreview) {

        pdf.addImage(

          imagePreview,

          imageFormat,

          x,

          y,

          LABEL_WIDTH,

          LABEL_HEIGHT,

          undefined,

          "FAST"

        );

      }

      if (showBorder) {

        pdf.setDrawColor(
          0,
          0,
          0
        );

        pdf.setLineWidth(
          0.3
        );

        pdf.rect(

          x,

          y,

          LABEL_WIDTH,

          LABEL_HEIGHT

        );

      }

    }

  }

  pdf.save(

    `custom_${labelWidth}x${labelHeight}.pdf`

  );

  alert(

    `${totalLabels} labels generated (${cols} × ${rows})`

  );

}

